module.exports = "/images/discover-6.png";